<template>
  <div
    class="text-link"
    :class="{'disable':disable, 'able':!disable }"
    @click="onClick"
  >
    {{text}}
  </div>
</template>

<script>
export default {
  name: 'text-link',
  props: {
    text: { type: String },
    disable: {type: Boolean, default: false}
  },
  methods: {
    onClick () {
      if (!this.disable) {
        this.$emit('click-text', this.text)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import './../../unified.scss';
.text-link {
    margin: 0.7rem 0rem;
    text-align: center;
}
.able{
    color:blue;
}
.disable{
  color:#C3C3C3;
}
</style>



// WEBPACK FOOTER //
// src/components/Atoms/TextLink.vue